// extracted by mini-css-extract-plugin
export default {"container":"vr-z","heading":"wr-z","text":"xr-z","info":"yr-z","link":"zr-z","fullMaxWidth":"Ar-z"};